import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ScrollingGuideContext } from 'contexts/ScrollingGuide'
import { useSelector } from 'react-redux'
import { getIsCompletedSelector, getIsOfflineSelector } from 'redux/home/selectors'
import { store } from 'redux/configureStore'
const TheBanner = () => {
  const [nav, setNav] = useState(false)
  const navigate = useNavigate()
  const handleNav = () => {
    setNav(true)
  }
  const handleCloseNav = () => {
    setNav(false)
  }
  const handleScroll = (node) => {
    node.scrollIntoView({ behavior: 'smooth' })
  }

  const location = useLocation()
  const { isShowTips } = useContext(ScrollingGuideContext)
  const isCompleted = useSelector((state) => getIsCompletedSelector(state))
  return (
    <>
      {location.pathname !== '/thongtinnguoidung' && (
        <section className="banner">
          <picture>
            <source srcSet="assets/img/banner.webp" type="image/webp" fetchpriority="high" />
            <img className="img-full" src="assets/img/banner.png" alt="banner" fetchpriority="high" />
          </picture>
          <div className={`text-notice`}>*Vui lòng đọc kỹ phần Lưu ý</div>
          {isShowTips && !isCompleted && (
            <div className="group-action container">
              <div className="group-btn-inline">
                {/* <button
                  type="button"
                  className="btn btn-warning btn-block"
                  onClick={() => {
                    navigate("/");
                  }}
                >
                  <a href="#guide">HƯỚNG DẪN</a>
                </button> */}
                <a href="#joinNow">
                  <img className="img-scroll" src="assets/img/text-scroll.png" alt="scroll-down" />
                </a>
              </div>
            </div>
          )}
        </section>
      )}
    </>
  )
}

export default TheBanner
